type TypingIndicatorProps = {
  participantName: string;
};

export const TypingIndicator = ({ participantName }: TypingIndicatorProps) => {
  return (
    <div className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600">
      <div className="flex gap-1">
        <span
          className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
          style={{ animationDelay: '0ms' }}
        />
        <span
          className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
          style={{ animationDelay: '150ms' }}
        />
        <span
          className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
          style={{ animationDelay: '300ms' }}
        />
      </div>
      <span>{participantName} is typing...</span>
    </div>
  );
};

